import { render, staticRenderFns } from "./IndicatorComponent.vue?vue&type=template&id=2310fda6&scoped=true&"
import script from "./IndicatorComponent.vue?vue&type=script&lang=js&"
export * from "./IndicatorComponent.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorComponent.vue?vue&type=style&index=0&id=2310fda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2310fda6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VProgressCircular})
